import {
  FeatureFlag,
  FeatureFlagReadModel,
  FlagState
} from "featureFlags/domain/flag"

export class EnvVarFeatureFlagReadModel implements FeatureFlagReadModel {
  private readonly source: object

  constructor(environment: object) {
    this.source = environment
  }

  getByName = (flagName: string): FeatureFlag => {
    if (flagName in this.source) {
      // @ts-expect-error `flagName` key exists in environment
      const environmentVar = this.source[flagName]

      return new FeatureFlag(
        flagName,
        environmentVar === true || environmentVar === `true`
          ? FlagState.Enabled
          : FlagState.Disabled
      )
    } else {
      return new FeatureFlag(flagName, FlagState.Unknown)
    }
  }
}

export class LocalStorageFeatureFlagReadModel implements FeatureFlagReadModel {
  private readonly source: Storage

  constructor(localStorage: Storage) {
    this.source = localStorage
  }

  getByName = (flagName: string): FeatureFlag => {
    const item = this.source.getItem(flagName)
    if (item === `true`) {
      return new FeatureFlag(flagName, FlagState.Enabled)
    } else if (item === `false`) {
      return new FeatureFlag(flagName, FlagState.Disabled)
    } else {
      return new FeatureFlag(flagName, FlagState.Unknown)
    }
  }
}

export class CombinedSourcesFeatureFlagReadModel
  implements FeatureFlagReadModel
{
  private readonly localStorage: Storage
  private readonly environment: object

  constructor(localStorage: Storage, environment: object) {
    this.localStorage = localStorage
    this.environment = environment
  }

  getByName = (flagName: string): FeatureFlag => {
    const localStorageVar = this.localStorage.getItem(flagName)

    if (localStorageVar) {
      return new FeatureFlag(
        flagName,
        localStorageVar === `true` ? FlagState.Enabled : FlagState.Disabled
      )
    } else if (flagName in this.environment) {
      const environmentVar = this.environment[flagName]

      return new FeatureFlag(
        flagName,
        environmentVar === true || environmentVar === `true`
          ? FlagState.Enabled
          : FlagState.Disabled
      )
    } else {
      return new FeatureFlag(flagName, FlagState.Unknown)
    }
  }
}

export class AllFlagsDisabledReadModel implements FeatureFlagReadModel {
  getByName = (flagName: string): FeatureFlag =>
    new FeatureFlag(flagName, FlagState.Disabled)
}
